module.exports = __webpack_public_path__ + "static/media/atrium-2.4d566c46.jpg";